export function priceInfoModel(data) {
    const { currency, price } = data || {};

    return {
        currency: currency || "",
        price: price || ""
    }
};